import { styled } from 'baseui'

export const ToggleWrap = styled('div', {
  maxWidth: '26rem',
})

export const BreakTimer = styled('p', ({ $theme }) => ({
  marginTop: '0.5rem',
  marginBottom: 0,
  fontSize: '1.125rem',
  color: $theme.colors.textHeading,
}))

export const StartButtonOverrides = {
  BaseButton: {
    style: ({ $theme }: any) => ({
      backgroundColor: $theme.colors.primary,
    }),
  },
}

export const StopButtonOverrides = {
  BaseButton: {
    style: ({ $theme }: any) => ({
      backgroundColor: $theme.colors.warning,
      ':hover': {
        backgroundColor: $theme.colors.warning400,
      },
    }),
  },
}
